import React from "react";
import { configProps } from "../../types";
import { TableTitle } from "../../components/TableTitle";
import SearchBar from "../../components/SearchBar";
import { Button } from "primereact/button";
import { useAppDispatch } from "../../redux/store";
import { addNewSlice } from "../../redux/slices/addNew";

type LocationsToolbarProps = {
  config: configProps<"locations">;
  globalFilterValue: string;
  setGlobalFilterValue: React.Dispatch<React.SetStateAction<string>>;
};

export default function LocationsToolbar({
  config,
  globalFilterValue,
  setGlobalFilterValue,
}: LocationsToolbarProps) {
  const dispatch = useAppDispatch();

  const handleAddNew = () => {
    dispatch(
      addNewSlice.actions.openAddNewDialog({
        target: {
          field: "address",
          type: "address",
          initialValues: {},
        },
      }),
    );
  };

  return (
    <div className="toolbar">
      <div className="toolbar-first-row">
        <TableTitle title={config.title} />
        <Button
          label="Dodaj nowy"
          icon="pi pi-plus"
          iconPos="right"
          onClick={handleAddNew}
        />
      </div>
      <div className="toolbar-second-row flex-start">
        <SearchBar
          globalFilterValue={globalFilterValue}
          setGlobalFilterValue={setGlobalFilterValue}
        />
      </div>
    </div>
  );
}
